export const RATE_COLOR = {
    RED_UP: 'redup',
    RED_DOWN: 'reddown'
};

export const RATE_TREBD = {
    UP: 'up',
    DOWN: 'down'
};

export const MAX_STOCK_NUM = 10;

export const REGION_TYPE_MAP = {
    HK: 'HK',
    SG: 'SG',
    US: 'US',
    MY: 'MY',
    JP: 'JP',
    AU: 'AU',
    CA: 'CA'
};

export const MARKET_MAP = {
    market1: 'HK',
    market2: 'MF',
    market3: 'PF',
    market4: 'BD',
    market5: 'US',
    market6: 'FX',
    market7: 'SH',
    market8: 'SZ',
    market9: 'CN',
    market10: 'SG',
    market11: 'JP',
    market12: 'DE',
    market13: 'CC',
    market14: 'TW',
    market15: 'MY',
    market16: 'FR',
    market17: 'NL',
    market18: 'PT',
    market19: 'BE',
    market20: 'GB',
    market21: 'IT',
    market22: 'CA',
    market23: 'AU',
    market24: 'KR',
    market25: 'BJ',
    market26: 'IN',
    market27: 'SN',
    market28: 'CFD',
    market29: 'EC',
    market30: 'IP'
};

export const CONTENT_TYPE = {
    IMG: 1,
    INDICATOR: 2,
    ORDERED_CONTENT: 3,
    UNORDERED_CONTENT: 4
};

export const COLOR_DIRECTION = {
    UP: 'up',
    DOWN: 'down',
    FLAT: 'flat',
    COUSTOM: 'coustom'
};

export const STOCK_INFO = {
    YES: 1,
    NO: 0
};

export const NUM_MAP = {
    TWO: 2,
    THREE: 3
};

export const APP_TYPE_MAP = {
    NN: 'nn',
    MOOMOO: 'moomoo'
};

export const BASE_URL_MAP = {
    nn: 'https://us-quote-logo-img-1251001049.cos.na-ashburn.myqcloud.com/minilogo',
    moomoo: 'https://quote-logo-img-1251001049.cos.ap-guangzhou.myqcloud.com/minilogo'
};
